// Дата рождения самого пользователя: проверка перед отправкой и верхняя граница пикера.
// Правило (порог 14+, арифметика возраста) живёт в контрактах и одинаково у сервера и у
// интерфейса — здесь только переход от `Date` из пикера к календарным частям в поясе человека.
// Спека 02 §A2, таблица «Валидации»; обоснование порога — docs/legal.md §4.6.

import type { BirthDateRejection } from '@lunya/contracts'
import { checkBirthDate, localDateParts, maxAllowedBirthDateParts } from '@lunya/contracts'

export type BirthDateErrorCode = BirthDateRejection

export type BirthDateValidationResult = { valid: true } | { valid: false; code: BirthDateErrorCode }

/**
 * Дата из будущего → `FUTURE`. Возраст меньше порога → `TOO_YOUNG`.
 * `now` вынесен параметром — иначе тест на границе возраста был бы завязан на реальные часы.
 */
export function validateBirthDate(
  birthDate: Date,
  now: Date = new Date(),
): BirthDateValidationResult {
  const check = checkBirthDate(localDateParts(birthDate), localDateParts(now))

  return check === 'OK' ? { valid: true } : { valid: false, code: check }
}

/**
 * Самая поздняя дата рождения, которую можно выбрать: сегодня минус порог. Ограничивает барабаны
 * шторки даты — и в онбординге, и в карточке данных профиля, — поэтому «из будущего» и «младше
 * 14» пальцем недостижимы. Проверка `validateBirthDate` остаётся вторым рубежом: между открытием
 * шторки и подтверждением мог смениться день, а дата может прийти из черновика или старых данных.
 */
export function resolveMaxBirthDate(now: Date = new Date()): Date {
  const { year, month, day } = maxAllowedBirthDateParts(localDateParts(now))

  return new Date(year, month - 1, day)
}
